export const LOAD_DATA = 'TABLE_DASHBOARD/LOAD_DATA';
export const UPDATE_DATA = 'TABLE_DASHBOARD/UPDATE_DATA';
export const CHANGE_MODAL_DATA = 'UI/CHANGE_DATE_DATA';
export const FILTER_DATA = 'TABLE_DASHBOARD/FILTER_DATA';
export const TOTAL_ORDERS = 'TABLE_DASHBOARD/TOTAL_ORDERS';
export const LOAD_DOCTOR_LIST = 'TABLE_DASHBOARD/LOAD_DOCTOR_LIST';
export const UPDATED_ORDER = 'ORDER/UPDATED';
